import { createEnv } from '@awpmarine/core/create-env';
import { keys as core } from '@awpmarine/core/keys';
import { z } from 'zod';

export const env = createEnv({
  extends: [core()],
  server: {
    // Front Door's profile ID. When set, production refuses requests that did not come through it.
    AZURE_FRONT_DOOR_ID: z.uuid().optional(),
  },
  client: {
    VITE_LOG_LEVEL: z.enum(['trace', 'debug', 'info', 'warning', 'error', 'fatal']).optional(),
    VITE_API_URL: z.url().default('https://api.awpmarine.co.uk'),
    VITE_APP_URL: z.url().default('https://app.awpmarine.co.uk'),
    VITE_DASH0_ENDPOINT: z.url().default('https://ingress.eu-west-1.aws.dash0.com'),
    VITE_DASH0_AUTH_TOKEN: z.string().min(1).optional(), // Ingest-scoped; it ships to the browser
    VITE_DASH0_DATASET: z.string().min(1), // Must already exist in Dash0
    VITE_PLAUSIBLE_ENDPOINT: z.url().optional(),
  },
  clientRuntimeEnv: {
    VITE_LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL,
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_APP_URL: import.meta.env.VITE_APP_URL,
    VITE_DASH0_ENDPOINT: import.meta.env.VITE_DASH0_ENDPOINT,
    VITE_DASH0_AUTH_TOKEN: import.meta.env.VITE_DASH0_AUTH_TOKEN,
    VITE_DASH0_DATASET: import.meta.env.VITE_DASH0_DATASET,
    VITE_PLAUSIBLE_ENDPOINT: import.meta.env.VITE_PLAUSIBLE_ENDPOINT,
  },
});
